// startup
// Load entry module and return exports
__webpack_require__("./bannerloader.js");
__webpack_require__("./betting.js");
// This entry module used 'module' so it can't be inlined
__webpack_require__("./classie.js");
__webpack_require__("./fixtures.js");
__webpack_require__("./league.js");
__webpack_require__("./main.js");
__webpack_require__("./match.js");
__webpack_require__("./merchandise.js");
__webpack_require__("./sideMenu.js");
__webpack_require__("./team.js");
__webpack_require__("./tv.js");
__webpack_require__("./vm.js");
__webpack_require__("./widgetbuilder.js");
__webpack_require__("./login.js");
var __webpack_exports__ = __webpack_require__("./player.js");
